import { render, staticRenderFns } from "./SchemaSelectConfig.vue?vue&type=template&id=42eca3f1"
import script from "./SchemaSelectConfig.vue?vue&type=script&lang=js"
export * from "./SchemaSelectConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports